import React from "react";

export default function IntroMystio() {
  return (
    <section className="w-full py-16 px-4 md:px-8 bg-black text-white text-center">
      <div className="max-w-4xl mx-auto flex flex-col items-center">
        {/* Title */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold font-oswald text-secondary tracking-widest uppercase mb-6 leading-tight">
          MYSTIO GLOBAL LOGISTICS — MOVING THE WORLD FORWARD
        </h2>

        {/* Divider lines decoration */}
        <div className="flex items-center justify-center gap-3 w-32 mb-6">
          <div className="h-[1px] bg-secondary/30 flex-1"></div>
          <div className="w-1.5 h-1.5 rounded-full bg-secondary"></div>
          <div className="h-[1px] bg-secondary/30 flex-1"></div>
        </div>

        {/* Description */}
        <p className="text-gray-300 font-outfit text-sm sm:text-base md:text-lg leading-relaxed max-w-3xl">
          Mystio Global Logistics provides fast, reliable, and intelligent delivery solutions for creators, retailers, and consumers. From local dispatch to nationwide retail distribution, Mystio ensures your products move with precision, speed, and transparency.
        </p>
      </div>
    </section>
  );
}
